import { store } from 'app/store';
import {
    setSaveButtonEnabled
} from 'common/components/EditDrawer/editDrawerSlice';
import { License, LicenseFormatted } from 'common/types/Entities';
import { IEditingItemInfo, Operations } from 'common/types/TypeDefs';

import { LicenseItem } from './ILicenseCreateDrawerContent';

export const _checkRequiredFieldsAreNotEmpty = <T extends Record<string, unknown>>(requiredFields: T): boolean =>
    Object.values(requiredFields).every(fieldValue => fieldValue !== '' && fieldValue !== undefined);

export const _isEditFormInfoExists = (
    operation?: Operations,
    editingItemInfoParam?: IEditingItemInfo<License & LicenseItem> | undefined
): boolean => {
    const isEditFormInitialized = operation === Operations.Edit &&
        editingItemInfoParam?.editingRow;
    return !!isEditFormInitialized;
};

export const _dateIsValid = (date: string) => !Number.isNaN(new Date(date).getTime());

export const _convertDateToValidFormat = (date: string): string => {
    let validFormattedDate  = '';
    if(_dateIsValid(date)) {
        validFormattedDate = new Date(date).toISOString();
        return validFormattedDate;
    }
    return validFormattedDate;
};

export const _reformatDateString  = (date: string) => {
    const dates: string[] = date.split('/');
    const lastItem: string | undefined = dates.pop();
    if (lastItem) {
        dates.unshift(lastItem);
    }
    return (dates.map(subDate =>
        subDate.length < 2 ? '0' + subDate : subDate
    )).join('-');
};

export const _isCreateFormEnabled = (action: Operations, isOpenDrawer: boolean) => {
    return (action === Operations.Create) && isOpenDrawer;
};

export const _isEditFormEnabled = (action: Operations, isOpenDrawer: boolean) => {
    return (action === Operations.Edit) && isOpenDrawer;
};

export const _validateRequiredFieldsOnCreateEdit = <T extends Record<string, unknown>> (
    requiredFields: T,
    isDateValidationError: boolean,
    duplicatedCibsNotConfirmed: boolean
) => {
    const { dispatch } = store;
    if(!_checkRequiredFieldsAreNotEmpty(requiredFields) || isDateValidationError || duplicatedCibsNotConfirmed) {

        dispatch(setSaveButtonEnabled(false));
    } else {
        dispatch(setSaveButtonEnabled(true));
    }
};

export const _duplicatedCibsNotConfirmed= (cibsAlreadyExists: boolean, saveDuplicates: boolean) => {
    return cibsAlreadyExists && !saveDuplicates;
};

export const _cibsAlreadyExists = (licenses: LicenseFormatted[] ,billingRecord: string, id: string | undefined) => {
    return licenses.some(l =>
        (id === undefined || l.id !== id)
        && l.billingRecord?.toLowerCase() === (billingRecord || '').toLowerCase());
};
